let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2j6v3")).then(() => parcelRequire('7ylv2'));